import React from 'react' //{useState}
import SupportButtons from '../../modules/custom/supports/CustomerSupport'

const Support: React.FC = () => {


  return (
 

      <SupportButtons></SupportButtons>
 
 
  )
}

export {Support}
